import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../api';
import { getWordsByGroup } from '../db';
import './GroupView.css';

function GroupView() {
    const { groupId } = useParams();
    const navigate = useNavigate();
    const [words, setWords] = useState([]);

    useEffect(() => {
        api.getWords(groupId)
            .then(res => setWords(res.data))
            .catch(async (err) => {
                // 离线或后端不可达: 降级读 IndexedDB (规格 9: 所有组均可离线查看)
                console.error("获取词汇失败, 降级读离线缓存:", err);
                const local = await getWordsByGroup(groupId);
                setWords(local);
            });
    }, [groupId]);

    // 组内所有单词共享同一张思维导图，取首词的 picture_id（兼容 picture_id==groupid 约定）
    const pictureId = words.length > 0 ? words[0].picture_id : null;

    if (words.length === 0) {
        return (
            <div className="group-view-container">
                <div className="group-view-card">
                    <p className="loading">加载中...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="group-view-container">
            <div className="group-view-card">
                <div className="group-view-header">
                    <h1>Group {groupId} · 词汇预览</h1>
                    <p className="group-view-count">共 {words.length} 个单词（只读预览，不记录进度）</p>
                </div>

                {pictureId && (
                    <div className="group-image-section">
                        <img src={api.pictureUrl(pictureId)} alt="mindmap" />
                    </div>
                )}

                <div className="group-table-wrap">
                    <table className="group-word-table">
                        <thead>
                            <tr>
                                <th>单词</th>
                                <th>词性</th>
                                <th>中文释义</th>
                                <th>词根</th>
                                <th>词缀</th>
                                <th>例句</th>
                            </tr>
                        </thead>
                        <tbody>
                            {words.map(w => (
                                <tr key={w.id}>
                                    <td className="gw-word">{w.word}</td>
                                    <td className="gw-pos">{w.part_of_speech}</td>
                                    <td className="gw-cn">{w.chinese_meaning}</td>
                                    <td className="gw-root">{w.word_root}</td>
                                    <td className="gw-affix">{w.affix}</td>
                                    <td className="gw-ex">{w.example_sentence}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <button className="back-home" onClick={() => navigate('/')}>返回首页</button>
        </div>
    );
}

export default GroupView;
